import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

import { useForm } from "react-hook-form";
import { API_URL, useAxios } from "../../../../../utils/const";
import { useToast } from "../../../../../Context/ToastContext";
import { Message } from "primereact/message";
const UpdateModal = ({
  toggleModal,
  getCourseStudents,
  getCourseSession,
  student,
  course_type,
}) => {
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: student.student.name,
      description: student.description,
    },
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (student.check_in == null) {
          await getCurrentTime();
        } else {
          setValue("check_in", student.check_in);
        }
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const closeModal = () => {
    toggleModal(false);
  };

  const handleSave = async (formData) => {
    setLoading(true);
    try {
      await axiosInstance.put(
        `${API_URL}/course-attendances/${student.id}/${course_type}`,
        {
          check_in: formData.check_in,
          description: formData.description,
        }
      );
      getCourseSession();
      getCourseStudents();
      setLoading(false);
      setToastObj({ msg: "Data Berhasil diubah", type: "success" });
      closeModal();
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
      closeModal();
    }
  };

  const getCurrentTime = async () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0"); // Add leading zero if needed
    const minutes = String(now.getMinutes()).padStart(2, "0"); // Add leading zero if needed
    setValue("check_in", `${hours}:${minutes}`);
  };

  return loading == false ? (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Ubah Kehadiran</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* NAME */}
        <div className="form-group mb-3">
          <label className="form-label">Nama</label>
          <input
            {...register("name")}
            type="text"
            disabled
            className="form-control"
          />
        </div>

        {/* CHECK IN TIME */}
        <div className="form-group mb-3">
          <label className="form-label">Waktu Hadir</label>
          <input
            {...register("check_in", {
              required: "Waktu hadir tidak boleh kosong!",
            })}
            type="time"
            className="form-control"
          />
          {errors.check_in && (
            <div className="">
              <Message
                className="mt-2 d-flex"
                severity="error"
                text={errors.check_in.message}
              />
            </div>
          )}
        </div>

        {/* DESCRIPTION */}
        <div className="form-group mb-3">
          <label className="form-label">Keterangan</label>
          <textarea
            {...register("description")}
            className="form-control"
          ></textarea>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          Batal
        </Button>
        <Button
          variant="success"
          disabled={loading}
          onClick={handleSubmit(handleSave)}
        >
          {loading && (
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          )}
          <span className="ml-1">Simpan</span>
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Ubah Kehadiran</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12 text-center align-center">
          <h1>Mohon Tunggu</h1>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateModal;
